import React from 'react'
import { withIcon } from '../../withIcon'

function StarIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.993 1.87695C12.2309 1.87695 12.4482 2.01202 12.5534 2.22535L15.494 8.18357L22.0686 9.13642C22.3042 9.17055 22.4999 9.33553 22.5734 9.56191C22.6469 9.7883 22.5855 10.0368 22.4149 10.2028L17.6506 14.8404L18.774 21.3893C18.8142 21.6239 18.7177 21.861 18.5251 22.0008C18.3325 22.1406 18.0772 22.1588 17.8666 22.0479L11.9996 18.9562L6.11883 22.0482C5.90825 22.1589 5.65308 22.1404 5.46061 22.0006C5.26814 21.8608 5.17175 21.6238 5.21197 21.3893L6.33537 14.8404L1.57103 10.2028C1.40047 10.0368 1.33902 9.7883 1.41253 9.56191C1.48605 9.33553 1.68177 9.17055 1.91733 9.13642L8.492 8.18357L11.4325 2.22535C11.5378 2.01202 11.7551 1.87695 11.993 1.87695ZM11.993 3.91419L9.46744 9.03155C9.37636 9.21609 9.20028 9.34398 8.99662 9.37349L3.35161 10.1916L7.44292 14.1741C7.59044 14.3177 7.65778 14.5247 7.62298 14.7276L6.6581 20.3524L11.7091 17.6968C11.8914 17.6009 12.1092 17.601 12.2913 17.697L17.3276 20.3509L16.363 14.7276C16.3282 14.5247 16.3955 14.3177 16.543 14.1741L20.6343 10.1916L14.9893 9.37349C14.7857 9.34398 14.6096 9.21609 14.5185 9.03155L11.993 3.91419Z" fill={color}/>
    </svg>
  )
}

export default withIcon(StarIcon)
